'use client'

import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader,
} from '@react-google-maps/api'

import customCluster from '../../public/cluster.svg'
import mapMarker from '../../public/map-marker.svg'

export default function CustomGoogleMap({ data }) {
  const lat =
    Number(data?.coords?.lat) ||
    Number(data?.metadata?.gps?.lat) ||
    Number(data?.coords?.gps?.lat) ||
    0
  const lng =
    Number(data?.coords?.lng) ||
    Number(data?.metadata?.gps?.lng) ||
    Number(data?.coords?.gps?.lng) ||
    0

  const hasCoords = lat !== 0 || lng !== 0

  const markers = hasCoords
    ? [
        {
          lat,
          lng,
          key: data?.title || 'Location',
          handle: data?.title || 'Location',
        },
      ]
    : []

  const mapCenter =
    markers.length > 0
      ? markers[0]
      : {
          lat: 48.8566,
          lng: 2.3522,
        }

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,
    language: 'fr',
    region: 'FR',
  })

  if (!isLoaded) return <p>Loading</p>

  return (
    <GoogleMap
      mapContainerStyle={{
        height: '100%',
      }}
      options={{ 
       // mapId: '2342d5707c8734a35edebe12' , 
         mapId:"1cb8efb2afa25f81"
      }}
      center={mapCenter}
      zoom={6}
    >
      <MarkerClusterer
        options={{
          styles: [
            {
              url: customCluster.src,
              height: 54,
              width: 54,
              textColor: '#fff',
              textSize: 15,
            },
          ],
        }}
      >
        {(clusterer) => (
          <>
            {markers.map((marker, i) => (
              <Marker
                key={i}
                clusterer={clusterer}
                position={{ lat: marker.lat, lng: marker.lng }}
                title={marker.title}
                icon={{
                  url: mapMarker.src,
                  scaledSize: new window.google.maps.Size(60, 60),
                }}
              />
            ))}
          </>
        )}
      </MarkerClusterer>
    </GoogleMap>
  )
}
